import React, { Component } from 'react'
import history from '../common/history.js'
import { inject, observer } from 'mobx-react'

@inject('filtersStore')
@observer
class KeyLabel extends Component {
  toggleActive = (e) => {
    e.stopPropagation()
    this.addToTags()
    let params = this.props.filtersStore.toParams()
    history.push(`${window.location.pathname}?${params}`)
  }

  get isActive() {
    return !!this.props.filtersStore.and_tags.find((tag) => { return tag === this.props.uuid; });
  }

  addToTags() {
    this.props.filtersStore.page = 1;
    this.props.filtersStore.changeAndTags(this.props.uuid);
    window.scrollTo(0,0);
  }

  render() {
    const wrap = this.props.wrap;
    return (
      <div className=''>
        <button
          onClick={this.toggleActive}
        >
          <span className={`whitespace-nowrap text-xs px-1.5 py-1.5 rounded-sm ${this.isActive ? 'bg-orange-1 text-gray-16' : 'bg-gray-11 hover:bg-gray-8'}`}>
            {this.props.children}
          </span>
        </button>
      </div>
    )
  }
}

export default KeyLabel
